import Hls from 'hls.js'

// // if (Hls.isSupported()) {
//     const videoPlayer = document.querySelector('video')
// console.log(videoPlayer)
//     const video = document.querySelector('.video')
// console.log(video)
//     const videoSrc = video.dataset.src
// console.log(videoSrc)
//     if (Hls.isSupported()) {
//         var hls = new Hls()
//         hls.loadSource(videoSrc)
//         hls.attachMedia(videoPlayer)
//         // console.log(videoPlayer.canPlayType('application/vnd.apple.mpegurl') ? 'true' : 'false')
//         // videoPlayer.play()
//         // run media attach event handler
//         hls.on(Hls.Events.MEDIA_ATTACHED, () => {
//
//             videoPlayer.addEventListener('canplaythrough', () => {
//                 const playing = !!(videoPlayer.currentTime > 0 && !videoPlayer.paused && !videoPlayer.ended && videoPlayer.readyState > 2)
//                 // pause initially
//                 if (!playing) {
//                     videoPlayer.muted = true
//                     videoPlayer.pause()
//                 }
//                 videoPlayer.play()
//             })
//         })
//     }

// // HLS.js is not supported on platforms that do not have Media Source
// // Extensions (MSE) enabled.
// //
// // When the browser has built-in HLS support (check using `canPlayType`),
// // we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video
// // element through the `src` property. This is using the built-in support
// // of the plain video element, without using HLS.js.
// // else if (videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
// //     videoPlayer.src = videoSrc
// //     videoPlayer.play()
// // }
// // }
//
// // Initial load
//     if (document.readyState === 'loading') {
//         document.addEventListener('DOMContentLoaded', initVideoPlayers);
//     } else {
//         initVideoPlayers();  // If already loaded
//     }
//
// // Re-init after Blitz dynamics (key fix)
//     document.addEventListener('afterBlitzInjectAll', initVideoPlayers);


// src/js/stream.js

function initVideoPlayer() {
    const videoPlayer = document.querySelector('video');
    const video = document.querySelector('.video');
    if (!videoPlayer || !video) return; // safety

    const videoSrc = video.dataset.src;
    if (!videoSrc) return;

    if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(videoSrc);
        hls.attachMedia(videoPlayer);

        hls.on(Hls.Events.MEDIA_ATTACHED, () => {
            videoPlayer.muted = true;
            videoPlayer.play().catch(e => console.log("Play interrupted:", e));
        });
    } else if (videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
        videoPlayer.src = videoSrc;
        videoPlayer.muted = true;
        videoPlayer.play();
    }
}

// Make it globally available
window.initVideoPlayer = initVideoPlayer;

// Re-run whenever Sprig/htmx swaps in new content that might contain a player
document.body.addEventListener('htmx:afterSwap', (e) => {
    // Check if the swapped content (or its children) has the video element
    if (e.detail.target.matches('.video') || e.detail.target.querySelector('.video')) {
        initVideoPlayer();
    }
});

// Also run once on initial load
document.addEventListener('DOMContentLoaded', initVideoPlayer);

// // Run on initial page load
// document.addEventListener('DOMContentLoaded', initVideoPlayers);
//
// // CRITICAL: Run AGAIN after Blitz finishes injecting dynamic content
// document.addEventListener('afterBlitzInjectAll', () => {
//     // Small delay sometimes helps if injection is staggered
//     setTimeout(initVideoPlayers, 50);
// });
//
// // Optional extra safety: also listen to individual injections
// document.addEventListener('afterBlitzInject', initVideoPlayers);